import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAppContext } from '../../../../context/AppContext';

const Logo = () => {
  const appData = useAppContext();

  return (
    <NavLink exact={true} to="/login">
      <img
        src={appData.logo}
        alt="Client Logo"
        style={{ maxHeight: '100px', maxWidth: '350px' }}
      />
    </NavLink>
  );
};

export default Logo;
